export const KEY_UPLOADED = 'Google service account key successfully uploaded.';
export const KEY_DELETED = 'Google service account key successfully deleted.';
export const CONFIG_UPLOADED =
  'Google Workspace configuration successfully uploaded.';
export const CONFIG_DELETED =
  'Google Workspace configuration successfully deleted.';
